import React from 'react'
import CardsItem from './CardsItem';
import "./Cards.css";


function Cards() {
    return (
        <div className="cards">
            <h1>Check out these EPIC Destination !</h1>
            <div className="cards__container">
                <div className="cards__wrapper">
                    <ul className="cards__items">
                        <CardsItem src="images/img-9.jpg" text="Explore the hidden waterfall deep inside the Amazon Jungle"
                        label="Advanture" path="/services"/>
                        <CardsItem src="images/img-2.jpg" text="Travel to the islands Bali in a Private Cruise"
                        label="Luxury" path="/services"/>
                    </ul>
                    <ul className="cards__items">
                        <CardsItem src="images/img-8.jpg" text="Explore the hidden waterfall deep inside the Amazon Jungle"
                        label="Advanture" path="/sign-up"/>
                        <CardsItem src="images/img-4.jpg" text="Travel to the islands Bali in a Private Cruise"
                        label="Luxury" path="/products"/>
                        <CardsItem src="images/img-5.jpg" text="Travel to the islands Bali in a Private Cruise"
                        label="Luxury" path="/services"/>
                    </ul>
                    <ul className="cards__items">
                        <CardsItem src="image/banner.jpg" text="Explore the hidden waterfall deep inside the Amazon Jungle"
                        label="Advanture" path="/services"/>
                        <CardsItem src="image/shahid.svg" text="Travel to the islands Bali in a Private Cruise"
                        label="Luxury" path="/services"/>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Cards
